import { BreadCrumbs } from 'BreetComponents';

import type { IPinManagementFormWrapper } from './PinManagement.helpers';

const PinManagementFormWrapper = ({ title, children, isModal }: IPinManagementFormWrapper) => (
	<div className='subbodycontent'>
		{!isModal && (
			<BreadCrumbs
				noHome
				pageTitle={title}
			/>
		)}
		<div className='securityformwrapper'>{children}</div>
	</div>
);

export default PinManagementFormWrapper;
